import { css } from 'styled-components';
import {
  getTypography, TypographyName, ThemedFunctor, getSpacing, SpacingName,
} from '@doveit/lego';

export const base: ThemedFunctor = () => css`
  position: relative;
`;

export const title: ThemedFunctor = ({
  theme,
}) => css`
  ${getTypography(theme, TypographyName.H4)}
`;

export const text: ThemedFunctor = ({
  theme,
}) => css`
  ${getTypography(theme, TypographyName.BODY)}
  ${getSpacing.marginTop(theme, SpacingName.SMALLER)}
  color: ${theme.palettes.neutrals.dark};

  &:first-child {
    margin-top: 0;
  }
`;
